// 标准 API 响应格式（code, errmsg, systime, logid, data）
export interface AuthApiResponse<T> {
  code: number;
  errmsg: string;
  systime: string;
  logid: string;
  data: T;
}

// 用户信息类型
export interface User {
  user_id: string;
  email: string;
  avatar: string;
  name: string;
}

export interface OAuthProviderConfigRspData {
  provider: string;
  app_id?: string;
  appId?: string;
  client_id?: string;
  clientId?: string;
  authorize_url?: string;
  authorizeUrl?: string;
  scope: string;
  extra_authorize_params?: Record<string, string>;
  extraAuthorizeParams?: Record<string, string>;
}

export type GetOAuthProviderConfigResponse =
  AuthApiResponse<OAuthProviderConfigRspData>;

export interface WebSessionRspData {
  is_new_user?: boolean;
  isNewUser?: boolean;
}

export type GetAdminAccessRequest = Record<string, never>;

export interface GetAdminAccessRspData {
  is_admin?: boolean;
  isAdmin?: boolean;
  user_id?: string;
  userId?: string;
  permissions_enabled?: boolean;
  permissionsEnabled?: boolean;
  permissions?: string[];
}

export type GetAdminAccessResponse =
  | AuthApiResponse<GetAdminAccessRspData>
  | GetAdminAccessRspData;

// 获取用户信息请求
export type GetUserInfoRequest = Record<string, never>;

// 获取用户信息响应数据
export interface GetUserInfoRspData {
  user_id?: string;
  userId?: string;
  email: string;
  avatar: string;
  name: string;
}

// 获取用户信息响应
export type GetUserInfoResponse = AuthApiResponse<GetUserInfoRspData>;

export type LoginForOAuthWebSessionResponse =
  AuthApiResponse<WebSessionRspData>;

// 发送邮箱验证码请求
export interface SendEmailAuthCodeRequest {
  email: string;
  app_id: string;
}

// 发送邮箱验证码响应数据
export interface SendEmailAuthCodeRspData {
  success: boolean;
}

// 发送邮箱验证码响应
export type SendEmailAuthCodeResponse =
  AuthApiResponse<SendEmailAuthCodeRspData>;

// 验证邮箱验证码请求
export interface VerifyEmailAuthCodeRequest {
  email: string;
  code: string;
  app_id: string;
}

// 验证邮箱验证码响应数据
export type VerifyEmailAuthCodeResponse = AuthApiResponse<WebSessionRspData>;

// 登出请求
export interface LogoutRequest {
  app_id: string;
}

// 登出响应数据
export interface LogoutRspData {
  success: boolean;
}

// 登出响应
export type LogoutResponse = AuthApiResponse<LogoutRspData>;

// 认证类型枚举
export enum AuthType {
  Google = 1,
  GitHub = 2,
}
